import { ReactNode } from "react";
import MuiDrawer from "@material-ui/core/Drawer";
import styles from "./Sheet.module.scss";

interface SheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
  side?: "left" | "right";
}

interface SheetContentProps {
  children: ReactNode;
  side?: "left" | "right";
  className?: string;
}

interface SheetHeaderProps {
  children: ReactNode;
  className?: string;
}

interface SheetTitleProps {
  children: ReactNode;
  className?: string;
}

/**
 * Sheet component using Material UI Drawer
 */
export const Sheet = ({
  open,
  onOpenChange,
  children,
  side = "right",
}: SheetProps) => {
  return (
    <MuiDrawer
      anchor={side}
      open={open}
      onClose={() => onOpenChange(false)}
      classes={{ paper: styles.drawer }}
    >
      {children}
    </MuiDrawer>
  );
};

/**
 * SheetContent component wrapper
 */
export const SheetContent = ({
  children,
  side = "right",
  className = "",
}: SheetContentProps) => {
  return <div className={`sheet-content ${className}`}>{children}</div>;
};

/**
 * SheetHeader component wrapper
 */
export const SheetHeader = ({ children, className = "" }: SheetHeaderProps) => {
  return <div className={`${styles.header} ${className}`}>{children}</div>;
};

/**
 * SheetTitle component wrapper
 */
export const SheetTitle = ({ children, className = "" }: SheetTitleProps) => {
  return <h2 className={`${styles.title} ${className}`}>{children}</h2>;
};

/**
 * Enhanced SheetWithDrawer component (alias for Sheet with Drawer)
 */
export const SheetWithDrawer = Sheet;
